module.exports = __webpack_public_path__ + "img/davide-marchet-web-developer-low.81fb504d.jpg";